import {
	ChangeDetectorRef,
	Component,
Inject,	EventEmitter,
	Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl, FormsModule} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Subject} from "rxjs";
import {Lieferant} from "../../shared/lieferant.model";
import {Data} from "../../providers/data";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {ErrorHelper} from "../../shared/error.helper";

const PATH_FILE = 'app/protected/lieferantenwechsel/lieferantenwechsel.component.ts';
const OBJ_LNG_NAME = 'lieferant';
const BACKEND_PATH_PREFIX = 'lieferant/';
// const REST_API_BASE =
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
// 	( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
// 	( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
// 	oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
// 	REST_API_BASE +
// 	BACKEND_PATH_PREFIX; // z.B. tipp/

@Component({
    selector: 'oase-lieferantenwechsel',
    templateUrl: './lieferantenwechsel.component.html',
    styleUrls: ['./lieferantenwechsel.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, FlexModule]

})
export class LieferantenwechselComponent extends Tabelle<Lieferant> {

	lieferanten: Lieferant[] = new Array<Lieferant>();
	neu: Lieferant = null;
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredLieferanten: ReplaySubject<Lieferant[]> = new ReplaySubject<Lieferant[]>(1);

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();
    @Output() aktuellerLieferant = new EventEmitter<Lieferant>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
        private _data: Data,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/lieferant",
				PATH_FILE: PATH_FILE,
				extraDataForAdding: { }
			}
		);
		this.displayedColumns = ['lieferantennummer', 'name', 'adresse', 'aktion'];
	}

  public wechsleLieferant(lieferant: Lieferant){
    this.http
      .get<Lieferant>(this.REST_API + '/wechsle/' + lieferant.id)

      .subscribe(
        data => {
          // this.authService.storeNewToken(data);
          this._logger.log(PATH_FILE + ' - got answer data: ', data);
          this.neu=data;
          this.openSnackBar(this.translation.translate('lieferant.gewechselt', { lif: this.neu.name }));
          this._data.changeLieferant(data);
        },
        err => ErrorHelper.handleError(err,"Fehler beim wechseln von Lieferant",this._logger, this.translation)
      );
  }

	getApiParams() {
		return "seite";
	}

}


